var Index_top_partner_banner_slider = document.querySelector('.Index_top_partner_banner_slider');
if (Index_top_partner_banner_slider) {
    new Swiper('.Index_top_partner_banner_slider', {
        loop: true,
        grabCursor: true,
        spaceBetween: 0,
        slidesPerView: 1,
        watchSlidesProgress: true,
        draggable:!0,
        autoHeight:!1,
        watchOverflow:!0,
        threshold:10,
        mousewheel:{
            forceToAxis:!0
        },
        effect: "fade",
        speed: 300,
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        }
    })
}